import { render, staticRenderFns } from "./UserPageAsideComponent.vue?vue&type=template&id=46df4156"
import script from "./UserPageAsideComponent.vue?vue&type=script&lang=js"
export * from "./UserPageAsideComponent.vue?vue&type=script&lang=js"
import style0 from "./UserPageAsideComponent.vue?vue&type=style&index=0&id=46df4156&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports